import { createFileRoute } from '@tanstack/react-router'
import { orgInternSearchSchema } from '@/features/org-interns/filter-org-interns/model/orgInternSearch'
import { OrgInternsPage } from '@/pages/internships/ui/OrgInternsPage'

export const Route = createFileRoute('/org-interns')({
  validateSearch: orgInternSearchSchema,
  component: OrgInternsPage,
})
